import { getInitialState } from '@/store/modules/settings/helper';

import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export default {
  namespaced: true,
  state: getInitialState(),
  getters,
  actions,
  mutations,
}
